import { defineStore } from 'pinia';
import axios from 'axios';

export const useProductStore = defineStore('product', {
  state: () => ({
    productItems: [],
    requsitionItems: []
  }),

  getters: {
    productItemById: (state) => (id) => {
      return state.productItems.find(productItem => productItem.id === id);
    }
  },

  actions: {
    UPDATE_PRODUCT_ITEMS(payload) {
      this.productItems = payload;
    },
    UPDATE_REQI_ITEMS(payload) {
      this.requsitionItems = payload;
    },
    removeAllProducts() {
      this.productItems.splice(0);
      this.requsitionItems.splice(0);
    },
    getProductItems(apiUrl, headerjson) {
      axios.get(apiUrl + '/posproducts', headerjson).then((response) => {
        this.UPDATE_PRODUCT_ITEMS(response.data.data);
      });
    },
    getRequiItems(apiUrl) {
      axios.get(apiUrl + '/posproducts').then((response) => {
        this.UPDATE_REQI_ITEMS(response.data.data);
      });
    },
    removeAllProduct() {
      this.removeAllProducts();
    }
  }
});
